import React from "react";
import { HandleClinicFromURLScreen } from "~/features/book-appointment/SelectClinicScreen";

const Component = () => {
  return <HandleClinicFromURLScreen />;
};

export default Component;
